import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '../customer-billing-customer.model';
import { CustomerBillingOtherCustomerModel } from '../../customer-billing-other-customer/customer-billing-other-customer.model';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';
import { fiInvoiceMethodType } from '../../customer-billing-invoice/invoice-method-type';
import { fiPaymentMethodType } from '../../payment-method-type';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { CustomerService } from '@fi-app/customer-billing/customer-billing-customer/customer.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { createMap } from '@fi-shared/utils/create-map';

@Component({
    selector: 'fi-customer-billing-customer-view',
    templateUrl: './customer-billing-customer-view.component.html',
    styleUrls: ['./customer-billing-customer-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-view' },
    standalone: false,
})
export class CustomerBillingCustomerViewComponent implements OnInit {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() resellers: CustomerBillingOtherCustomerModel[];
    ContactPerson: BillingContactModel;
    InvoiceMethodType = fiInvoiceMethodType;
    BillingReference: BillingContactModel;
    EditTabs: EditTabsModel;

    private resellersMap: {
        [key: string]: CustomerBillingOtherCustomerModel;
    };

    constructor(
        private customerService: CustomerService,
        private stateService: FiStateService,
    ) {}

    ngOnInit() {
        this.ContactPerson = this.customer.Contacts.sort(comparator((item) => item.IsDefault, true))[0];
        this.BillingReference = this.customer.InvoiceInfo.BillingReference[0] || new BillingContactModel();
        this.resellersMap = createMap(this.resellers, 'Id');
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.customer.Name);
        this.EditTabs.Tabs.push(new EditTabModel('', ''));
    }

    isCreditCard(): boolean {
        return this.customer.PaymentMethodType === fiPaymentMethodType.CreditCard;
    }

    isInvoice(): boolean {
        return this.customer.PaymentMethodType === fiPaymentMethodType.Invoice;
    }

    getResellerName(resellerId: number): string {
        const reseller = this.resellersMap[resellerId];
        return reseller ? reseller.Name : this.customer.DefaultResellerName;
    }

    getShutOffDateClass() {
        return this.customerService.getShutOffDateClass(this.customer);
    }

    editCustomer() {
        this.stateService.go(FiStateNames.CustomerBilling.Customers.Edit, { Id: this.customer.CustomerId });
    }
}
